export function getErrorMessage(message: string | undefined): string {
  return message || 'Не пришло сообщение об ошибке';
}
